import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import 'animate.css';
import axios from 'axios';
import "react-datepicker/dist/react-datepicker.css";
import { Util } from './config/Util';
import { BrowserRouter as Router } from "react-router-dom"; 

if(window.location.hostname === "localhost"){
  axios.defaults.baseURL = 'https://d2c4d2pjttf9c7.cloudfront.net/elmaam-service';
  //axios.defaults.baseURL = 'https://d3n5fqj58n1oc2.cloudfront.net/elmaam-service';
}else if(window.location.hostname === "elmaam.com"){
  axios.defaults.baseURL = 'https://elmaam.com/elmaam-service';
}else{
  axios.defaults.baseURL = 'https://d2c4d2pjttf9c7.cloudfront.net/elmaam-service';
}
// Add a request interceptor
axios.interceptors.request.use(function (config) {
  const user_data = Util.getFromSession('auth');
  const tenantId = sessionStorage.getItem("tenantId")
  if(user_data && user_data.token){
    config.headers.Authorization =  `Bearer ${user_data.token}`;
  }
  if(tenantId){
    config.headers['x-tenant-id'] = tenantId;
  }
  return config;
});




// Put any other imports below so that CSS from your
// components takes precedence over default styles.
//Testing new branch

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
